import React from 'react';
import { connect } from 'react-redux';
import { withRouter, browserHistory } from 'react-router';
import * as FacilitiesActions from '../../actions/facilities_actions';
import { bindActionCreators } from 'redux';
import Header from '../../components/header';
import { ModalDialogCommon } from '../modal_dialog_common';
import { validate } from '../../validations';
import InputMask from 'react-input-mask';
let screenIdentifier = 'facilities_admin';

export var FacilitiesAdmin = React.createClass({
    getInitialState() {
        return {
            editMode: false,
            showModal: false,
            modal: false,
            mobileCssClass: "inputText",addFaciltyClicked:false,adminAdded:false,adminAddedMsg:null,adminboxClosed:false,
        }
    },
    componentWillMount() {

        this.props.FacilitiesDetails.FaciliteAdmin = null
    },
    componentWillReceiveProps(nextProps) {


        if (nextProps.FacilitiesDetails.FaciliteAdmin.status == 200) {

             if(this.state.addFaciltyClicked){

              this.setState({addFaciltyClicked:false,adminAdded:true,adminAddedMsg:nextProps.FacilitiesDetails.FaciliteAdmin.message}) ;
             }


            if (nextProps.FacilitiesDetails.FaciliteDetailsByID ? nextProps.FacilitiesDetails.FaciliteDetailsByID.status == 200 : false ) {
              if(this.state.adminboxClosed) {
                  this.props.router.push('/facilities/details');
                  this.setState({adminboxClosed:false})
              }
            }

        }
        else {
            // alert(nextProps.FacilitiesDetails.FaciliteAdmin.message)
            this.setState({ showModal: true });

        }


    },
    componentDidMount() {

    },
    email_validate(event) {
        let email = event.target.value;
        let isEmailTrue = validate.email(email);
        isEmailTrue ? event.target.className = 'inputText' : event.target.className = 'inputText error';

    },
    phon_validate(event) {
        let mobile = event.target.value;
        let isMobileTrue = validate.phone(mobile);
        isMobileTrue ? event.target.className = 'inputText' : event.target.className = 'inputText error';

    },
    remove_error(event) {
        event.target.className = 'inputText';
    },
    no_empty(event) {
        let value = event.target.value;
        let isEmptyValue = validate.notEmpty(value);
        isEmptyValue ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    add_facility_admin() {

        var facility_id = window.location.search ? validate.getUrlParam('id') : window.location.hash === "#new" ? this.props.FacilitiesDetails.FaciliteCreateDeatils.data.id : this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
        let firstName = this.refs.firstName.value.trim(),
            lastName = this.refs.lastName.value.trim(),
            mobile = this.refs.mobile.state.value.replace(/ /g, ""),
            email = this.refs.email.value.trim();
        let isEmailTrue = validate.email(email);
        let isPhoneTrue = validate.phone(mobile);

        !firstName.length ? this.refs.firstName.className = "inputText error" : this.refs.firstName.className = "inputText";
        !lastName.length ? this.refs.lastName.className = "inputText error" : this.refs.lastName.className = "inputText";
        !isEmailTrue ? this.refs.email.className = "inputText error" : this.refs.email.className = "inputText";
        !isPhoneTrue ? this.setState({ mobileCssClass: "inputText error" }) : this.setState({ mobileCssClass: "inputText" });
        let adminFacilityRoleId = this.refs.facilityRoleId.value.trim();
        !adminFacilityRoleId.length ? this.refs.facilityRoleId.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom' : this.refs.facilityRoleId.parentElement.parentElement.parentElement.className = 'aj-dropdown';

        if (firstName.length && lastName.length && mobile.length && isEmailTrue && isPhoneTrue && adminFacilityRoleId.length) {
            var data = {
                "firstName": firstName,
                "lastName": lastName,
                "mobile": mobile,

                "email": email,
                "createdBy": { "id": this.props.LogingDetails.data.id, role: { "id": this.props.UserDetails.selectedUserRoleID } },//facility id
                "facility": { "id": facility_id },
                "role": { "id": 2 },
                "facilityRole": { "id": adminFacilityRoleId }
            };

            this.props.Dispatch(FacilitiesActions.createFaclityAdmin(data));
            this.setState({addFaciltyClicked:true}) ;
        }
        else {
            this.setState({ modal: true });
        }

    },
    cancel() {

        this.props.router.goBack();
    },
    closebox() {
        this.setState({ showModal: false, modal: false });
    },

    selectionChanged(event) {
        event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';
    },
    closeadminAddedbox(){
        let fa_id = window.location.search ? validate.getUrlParam('id') : window.location.hash === "#new" ? this.props.FacilitiesDetails.FaciliteCreateDeatils.data.id : this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
        this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(fa_id));
          this.setState({ adminAdded: false,adminboxClosed:true });
    },
    render() {
   
        return (
            <div className="dashboard-inner-content" >
                <Header screenIdentifier={screenIdentifier} />
                <div className="white-box">
                    <div className="recovery-facility">
                        <h4>Add Mobi Admin Details</h4>
                        <div className="row">
                            <div className="col-xs-11 no-padding">
                                <div className="col-xs-6 no-padding staff-recovery">
                                    <div className="input-group">
                                        <input type="text" className="inputText" onFocus={this.remove_error} onBlur={this.no_empty} ref="firstName" maxLength="64" required />
                                        <span className="floating-label">First Name</span>
                                    </div>
                                    <div className="input-group">
                                        <input type="text" className="inputText" onFocus={this.remove_error} onBlur={this.no_empty} ref="lastName" maxLength="64" required />
                                        <span className="floating-label">Last Name</span>
                                    </div>
                                    <div className="input-group">
                                        <input type="text" className="inputText" onFocus={this.remove_error} onBlur={this.email_validate} ref="email" required />
                                        <span className="floating-label">Email</span>
                                    </div>
                                    <div className="input-group">
                                        <InputMask type="text" className={this.state.mobileCssClass} required onFocus={this.remove_error} onBlur={this.phon_validate} ref="mobile" mask="999 999 9999" maskChar={null}></InputMask>
                                        <span className="floating-label">Phone</span>
                                    </div>

                                    <div className="row">
                                        <div className="col-xs-12 no-padding ">
                                            <div className="aj-dropdown">
                                                <div className="source">
                                                    <div className="question-selection">
                                                        <select ref="facilityRoleId" onChange={this.selectionChanged}>
                                                            {/* <option value="" default>Clinic Role</option>
                                                            <option value="3" >Psychiatrist  Support Staff</option>
                                                            <option value="4" >Therapist</option>
                                                            <option value="6" >Administrative Staff</option> */}
                                                            <option value="" default> Professional Role </option>
                                                            {/* <option value="3" >Psychiatrist Support Staff</option>
                                                            <option value="4" >Therapist</option> */}
                                                            {/* <option value="6" >Administrative Staff</option> */}
                                                            <option value="9" >Clinician/Therapist</option>
                                                            <option value="10" >Prescriber/Psychiatrist/Other Medical Personnel</option>
                                                            <option value="11" >Clinical Supervisor/Team Lead</option>
                                                            <option value="12" >Clinic Coordinator</option>
                                                            <option value="13" >Administrative Support Staff</option>
                                                            <option value="14" >Family Advocate</option>
                                                            <option value="15" >Peer Support Specialist</option>
                                                            <option value="16" >Case Manager/Recovery Coach</option>
                                                            <option value="17" >Supported Education & Employment Specialist</option>
                                                            <option value="18" >Program Director</option>
                                                            <option value="19" >Research Staff/Site Coordinator</option>
                                                            <option value="20" >Other</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>



                        <div className="row">
                            <div className="col-xs-6 no-padding recovery-buttons">
                                <button className="white-button" onClick={this.add_facility_admin}>Send Invite</button>
                                <button className="gray-button" onClick={this.cancel} >cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div> {this.state.adminAdded ? <ModalDialogCommon message={this.state.adminAddedMsg} action={this.closeadminAddedbox} /> : ""}</div>
                <div> {this.state.showModal ? <ModalDialogCommon message={this.props.FacilitiesDetails.FaciliteAdmin.message} action={this.closebox} /> : ""}</div>
                <div> {this.state.modal ? <ModalDialogCommon message="Please enter necessary fields to proceed." action={this.closebox} /> : ""}</div>
            </div >

        );
    }
});


let mapStateToProps = (state) => {
    return {
        UserDetails:state.User,
        FacilitiesDetails: state.Facilites,
        LogingDetails: state.User.loginData
    };
};

let mapDispatchToProps = (dispatch) => ({
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(FacilitiesAdmin));



/** WEBPACK FOOTER **
 ** ./src/components/facilitiesScreen/add-facility-admin.js
 **/